import { Injectable, Inject, Optional, ɵɵdefineInjectable, ɵɵinject, Component, Injector, NgZone, Renderer2, Input, NgModule, APP_INITIALIZER } from '@angular/core';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { from, throwError, BehaviorSubject } from 'rxjs';
import { EnvironmentService } from '@mt-ng2/environment-module';
import { NotificationsService } from '@mt-ng2/notifications-module';
import { markAllFormFieldsAsTouched } from '@mt-ng2/common-functions';
import { AuthService, MtAuthGuard } from '@mt-ng2/auth-module';
import { PageTitlesService, PageTitlesModule } from '@mt-ng2/page-titles';
import { LoginComponentLink, LoginModuleConfigToken, LoginModuleOverrideAuthServiceToken } from '@mt-ng2/login-module-config';
import { StorageService } from '@mt-ng2/common-classes';
import { DOCUMENT, CommonModule } from '@angular/common';
import { CookieService } from 'ngx-cookie';
import { MsalService, MsalModule, MSAL_INSTANCE } from '@azure/msal-angular';
import { finalize } from 'rxjs/operators';
import { NavService } from '@mt-ng2/nav-module';
import { MtPreventDoubleClickButtonModule } from '@mt-ng2/disable-double-click';
import { PublicClientApplication, BrowserCacheLocation } from '@azure/msal-browser';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@mt-ng2/common-classes';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/forms';
import * as ɵngcc4 from '@angular/router';
import * as ɵngcc5 from 'ngx-cookie';
import * as ɵngcc6 from '@mt-ng2/auth-module';
import * as ɵngcc7 from '@mt-ng2/disable-double-click';

function LoginComponent_div_9_form_2_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵtext(1, "Username is required");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("position", "absolute");
} }
function LoginComponent_div_9_form_2_div_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵtext(1, "Password is required");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("position", "absolute");
} }
function LoginComponent_div_9_form_2_div_25_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵelement(2, "input", 22);
    ɵngcc0.ɵɵtext(3, "\n                            ");
    ɵngcc0.ɵɵelementStart(4, "label", 23);
    ɵngcc0.ɵɵtext(5, " Remember Me");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
} }
function LoginComponent_div_9_form_2_div_27_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵelement(2, "input", 24);
    ɵngcc0.ɵɵtext(3, "\n                            ");
    ɵngcc0.ɵɵelementStart(4, "label", 25);
    ɵngcc0.ɵɵtext(5, " Remember My Username");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
} }
function LoginComponent_div_9_form_2_div_29_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div");
} }
function LoginComponent_div_9_form_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "form", 8);
    ɵngcc0.ɵɵlistener("submit", function LoginComponent_div_9_form_2_Template_form_submit_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.onLogin(); });
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelementStart(2, "div", 9);
    ɵngcc0.ɵɵtext(3, "\n                    ");
    ɵngcc0.ɵɵelement(4, "input", 10);
    ɵngcc0.ɵɵtext(5, "\n                    ");
    ɵngcc0.ɵɵelement(6, "span", 11);
    ɵngcc0.ɵɵtext(7, "\n                    ");
    ɵngcc0.ɵɵtemplate(8, LoginComponent_div_9_form_2_div_8_Template, 2, 2, "div", 12);
    ɵngcc0.ɵɵtext(9, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(10, "\n                ");
    ɵngcc0.ɵɵelementStart(11, "div", 9);
    ɵngcc0.ɵɵtext(12, "\n                    ");
    ɵngcc0.ɵɵelement(13, "input", 13, 14);
    ɵngcc0.ɵɵtext(15, "\n                    ");
    ɵngcc0.ɵɵelement(16, "span", 15);
    ɵngcc0.ɵɵtext(17, "\n                    ");
    ɵngcc0.ɵɵtemplate(18, LoginComponent_div_9_form_2_div_18_Template, 2, 2, "div", 12);
    ɵngcc0.ɵɵtext(19, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(20, "\n                ");
    ɵngcc0.ɵɵelementStart(21, "div", 16);
    ɵngcc0.ɵɵtext(22, "\n                    ");
    ɵngcc0.ɵɵelementStart(23, "div", 17);
    ɵngcc0.ɵɵtext(24, "\n                        ");
    ɵngcc0.ɵɵtemplate(25, LoginComponent_div_9_form_2_div_25_Template, 7, 0, "div", 18);
    ɵngcc0.ɵɵtext(26, "\n                        ");
    ɵngcc0.ɵɵtemplate(27, LoginComponent_div_9_form_2_div_27_Template, 7, 0, "div", 18);
    ɵngcc0.ɵɵtext(28, "\n                        ");
    ɵngcc0.ɵɵtemplate(29, LoginComponent_div_9_form_2_div_29_Template, 1, 0, "div", 19);
    ɵngcc0.ɵɵtext(30, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(31, "\n                    ");
    ɵngcc0.ɵɵelementStart(32, "button", 20);
    ɵngcc0.ɵɵtext(33);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(34, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(35, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r3.loginForm);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("has-error", ctx_r3.showUsernameRequiredError());
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.showUsernameRequiredError());
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵclassProp("has-error", ctx_r3.showPasswordRequiredError());
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.showPasswordRequiredError());
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r3.rememberOption);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "rememberMe");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "userName");
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r3.loginForm.valid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\n                        ", ctx_r3.config.messageOverrides.signInButtonText, "\n                    ");
} }
function LoginComponent_div_9_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelement(2, "span", 26);
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵtext(4, "\n            ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const link_r13 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("innerHtml", link_r13.linkHtml, ɵngcc0.ɵɵsanitizeHtml)("routerLink", link_r13.routerLinkPath);
} }
function LoginComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵtemplate(2, LoginComponent_div_9_form_2_Template, 36, 12, "form", 6);
    ɵngcc0.ɵɵtext(3, "\n\n            ");
    ɵngcc0.ɵɵtemplate(4, LoginComponent_div_9_ng_container_4_Template, 5, 2, "ng-container", 7);
    ɵngcc0.ɵɵtext(5, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.loginForm);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.config.loginComponentLinks);
} }
function LoginComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelement(2, "br");
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelement(4, "app-google-login", 27);
    ɵngcc0.ɵɵtext(5, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("config", ctx_r1.config);
} }
function LoginComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelement(2, "br");
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelement(4, "app-ms-login", 27);
    ɵngcc0.ɵɵtext(5, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("config", ctx_r2.config);
} }
function ForgotPasswordComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵtext(1, "Email is required");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("position", "block");
} }
function ForgotPasswordComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵtext(1, "\n                    Invalid email address. Valid e-mail can contain only letters, numbers and '@'\n                ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("position", "block");
} }
function ResetPasswordComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtext(1, "Password is required");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("position", "block");
} }
function ResetPasswordComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtext(1, "Passwords must match");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("position", "block");
} }
function ResetPasswordComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("position", "block");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\n                    ", ctx_r3.config.messageOverrides.failedPattern, "\n                ");
} }
function ResetPasswordComponent_div_38_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtext(1, "\n                        Secondary Password is required\n                    ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("position", "block");
} }
function LoginOldStyleComponent_div_9_form_2_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵtext(1, "Username is required");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("position", "absolute");
} }
function LoginOldStyleComponent_div_9_form_2_div_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵtext(1, "Password is required");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("position", "absolute");
} }
function LoginOldStyleComponent_div_9_form_2_div_25_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵelement(2, "input", 22);
    ɵngcc0.ɵɵtext(3, "\n                            ");
    ɵngcc0.ɵɵelementStart(4, "label", 23);
    ɵngcc0.ɵɵtext(5, " Remember Me");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
} }
function LoginOldStyleComponent_div_9_form_2_div_27_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵelement(2, "input", 24);
    ɵngcc0.ɵɵtext(3, "\n                            ");
    ɵngcc0.ɵɵelementStart(4, "label", 25);
    ɵngcc0.ɵɵtext(5, " Remember My Username");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
} }
function LoginOldStyleComponent_div_9_form_2_div_29_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div");
} }
function LoginOldStyleComponent_div_9_form_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "form", 8);
    ɵngcc0.ɵɵlistener("submit", function LoginOldStyleComponent_div_9_form_2_Template_form_submit_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.onLogin(); });
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelementStart(2, "div", 9);
    ɵngcc0.ɵɵtext(3, "\n                    ");
    ɵngcc0.ɵɵelement(4, "input", 10);
    ɵngcc0.ɵɵtext(5, "\n                    ");
    ɵngcc0.ɵɵelement(6, "span", 11);
    ɵngcc0.ɵɵtext(7, "\n                    ");
    ɵngcc0.ɵɵtemplate(8, LoginOldStyleComponent_div_9_form_2_div_8_Template, 2, 2, "div", 12);
    ɵngcc0.ɵɵtext(9, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(10, "\n                ");
    ɵngcc0.ɵɵelementStart(11, "div", 9);
    ɵngcc0.ɵɵtext(12, "\n                    ");
    ɵngcc0.ɵɵelement(13, "input", 13, 14);
    ɵngcc0.ɵɵtext(15, "\n                    ");
    ɵngcc0.ɵɵelement(16, "span", 15);
    ɵngcc0.ɵɵtext(17, "\n                    ");
    ɵngcc0.ɵɵtemplate(18, LoginOldStyleComponent_div_9_form_2_div_18_Template, 2, 2, "div", 12);
    ɵngcc0.ɵɵtext(19, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(20, "\n                ");
    ɵngcc0.ɵɵelementStart(21, "div", 16);
    ɵngcc0.ɵɵtext(22, "\n                    ");
    ɵngcc0.ɵɵelementStart(23, "div", 17);
    ɵngcc0.ɵɵtext(24, "\n                        ");
    ɵngcc0.ɵɵtemplate(25, LoginOldStyleComponent_div_9_form_2_div_25_Template, 7, 0, "div", 18);
    ɵngcc0.ɵɵtext(26, "\n                        ");
    ɵngcc0.ɵɵtemplate(27, LoginOldStyleComponent_div_9_form_2_div_27_Template, 7, 0, "div", 18);
    ɵngcc0.ɵɵtext(28, "\n                        ");
    ɵngcc0.ɵɵtemplate(29, LoginOldStyleComponent_div_9_form_2_div_29_Template, 1, 0, "div", 19);
    ɵngcc0.ɵɵtext(30, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(31, "\n                    ");
    ɵngcc0.ɵɵelementStart(32, "button", 20);
    ɵngcc0.ɵɵtext(33);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(34, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(35, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r3.loginForm);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("has-error", ctx_r3.showUsernameRequiredError());
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.showUsernameRequiredError());
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵclassProp("has-error", ctx_r3.showPasswordRequiredError());
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.showPasswordRequiredError());
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r3.rememberOption);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "rememberMe");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "userName");
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r3.loginForm.valid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\n                        ", ctx_r3.config.messageOverrides.signInButtonText, "\n                    ");
} }
function LoginOldStyleComponent_div_9_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelement(2, "span", 26);
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵtext(4, "\n            ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const link_r13 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("innerHtml", link_r13.linkHtml, ɵngcc0.ɵɵsanitizeHtml)("routerLink", link_r13.routerLinkPath);
} }
function LoginOldStyleComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵtemplate(2, LoginOldStyleComponent_div_9_form_2_Template, 36, 12, "form", 6);
    ɵngcc0.ɵɵtext(3, "\n\n            ");
    ɵngcc0.ɵɵtemplate(4, LoginOldStyleComponent_div_9_ng_container_4_Template, 5, 2, "ng-container", 7);
    ɵngcc0.ɵɵtext(5, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.loginForm);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.config.loginComponentLinks);
} }
function LoginOldStyleComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelement(2, "br");
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelement(4, "app-google-login", 27);
    ɵngcc0.ɵɵtext(5, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("config", ctx_r1.config);
} }
function LoginOldStyleComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelement(2, "br");
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelement(4, "app-ms-login", 27);
    ɵngcc0.ɵɵtext(5, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("config", ctx_r2.config);
} }
function ForgotPasswordOldStyleComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵtext(1, "Email is required");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("position", "block");
} }
function ForgotPasswordOldStyleComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵtext(1, "\n                    Invalid email address. Valid e-mail can contain only letters, numbers and '@'\n                ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("position", "block");
} }
function ResetPasswordOldStyleComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtext(1, "Password is required");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("position", "block");
} }
function ResetPasswordOldStyleComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtext(1, "Passwords must match");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("position", "block");
} }
function ResetPasswordOldStyleComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("position", "block");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\n                    ", ctx_r3.config.messageOverrides.failedPattern, "\n                ");
} }
function ResetPasswordOldStyleComponent_div_38_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtext(1, "\n                        Secondary Password is required\n                    ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("position", "block");
} }
class LoginConfig {
    constructor(config) {
        var _a, _b, _c, _d, _e, _f;
        if (!config) {
            config = {};
        }
        this.rememberFeature = this._loadRememberFeature(config.rememberFeature);
        this.googleAuthConfig = (_a = config === null || config === void 0 ? void 0 : config.googleAuthConfig) !== null && _a !== void 0 ? _a : null;
        this.microsoftAuthConfig = (_b = config === null || config === void 0 ? void 0 : config.microsoftAuthConfig) !== null && _b !== void 0 ? _b : null;
        this.hideRegularSignIn = (_c = config === null || config === void 0 ? void 0 : config.hideRegularSignIn) !== null && _c !== void 0 ? _c : false;
        this.passwordPattern = config.passwordPattern
            ? new RegExp(config.passwordPattern)
            : new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[A-Za-z\\d!$%@#£€*?&]{8,}');
        this.loginComponentLinks = (_d = config === null || config === void 0 ? void 0 : config.loginComponentLinks) !== null && _d !== void 0 ? _d : [new LoginComponentLink('<a>I forgot my password</a>', '/forgotpassword')];
        this.messageOverrides = this._loadMessageOverrides((_e = config.messageOverrides) !== null && _e !== void 0 ? _e : {});
        this.useAssetsFolderForImages = (_f = config === null || config === void 0 ? void 0 : config.useAssetsFolderForImages) !== null && _f !== void 0 ? _f : false;
    }
    _loadMessageOverrides(messageOverrides) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        let defaultMessages = {};
        defaultMessages.failedPattern = (_a = messageOverrides.failedPattern) !== null && _a !== void 0 ? _a : LoginConfig.failedPattern;
        defaultMessages.forgotPasswordFailure = (_b = messageOverrides.forgotPasswordFailure) !== null && _b !== void 0 ? _b : LoginConfig.signInFailure;
        defaultMessages.forgotPasswordLabel = (_c = messageOverrides.forgotPasswordLabel) !== null && _c !== void 0 ? _c : LoginConfig.forgotPasswordLabel;
        defaultMessages.forgotPasswordSuccess = (_d = messageOverrides.forgotPasswordSuccess) !== null && _d !== void 0 ? _d : LoginConfig.forgotPasswordSuccess;
        defaultMessages.googleSignInFailure = (_e = messageOverrides.googleSignInFailure) !== null && _e !== void 0 ? _e : LoginConfig.signInFailure;
        defaultMessages.googleSignInFailureEmail = (_f = messageOverrides.googleSignInFailureEmail) !== null && _f !== void 0 ? _f : LoginConfig.googleSignInFailureEmail;
        defaultMessages.microsoftSignInFailureEmail = (_g = messageOverrides.microsoftSignInFailureEmail) !== null && _g !== void 0 ? _g : LoginConfig.microsoftSignInFailureEmail;
        defaultMessages.microsoftSignInFailure = (_h = messageOverrides.microsoftSignInFailure) !== null && _h !== void 0 ? _h : LoginConfig.signInFailure;
        defaultMessages.loginLabel = (_j = messageOverrides.loginLabel) !== null && _j !== void 0 ? _j : LoginConfig.loginLabel;
        defaultMessages.signInButtonText = (_k = messageOverrides.signInButtonText) !== null && _k !== void 0 ? _k : LoginConfig.signInButtonText;
        defaultMessages.userNamePasswordFailure = (_l = messageOverrides.userNamePasswordFailure) !== null && _l !== void 0 ? _l : LoginConfig.userNamePasswordFailure;
        defaultMessages.resetPasswordLabel = (_m = messageOverrides.resetPasswordLabel) !== null && _m !== void 0 ? _m : LoginConfig.resetPasswordLabel;
        return defaultMessages;
    }
    _loadRememberFeature(rememberFeature) {
        let defaultRemembers = { rememberOptions: 'rememberMe' };
        return rememberFeature !== null && rememberFeature !== void 0 ? rememberFeature : defaultRemembers;
    }
}
LoginConfig.ɵfac = function LoginConfig_Factory(t) { return new (t || LoginConfig)(ɵngcc0.ɵɵinject(LoginModuleConfigToken, 8)); };
LoginConfig.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: LoginConfig, factory: LoginConfig.ɵfac });
LoginConfig.failedPattern = 'Valid passwords must be at least 8 characters, have a capital letter and number.';
LoginConfig.forgotPasswordLabel = 'Provide the email associated with your account and click Submit. An email will be sent with a link to reset your password.';
LoginConfig.forgotPasswordSuccess = `Reset link generated. Please check your email for further instructions.`;
LoginConfig.googleSignInFailureEmail = `Email not found in our system. Please try again later, or contact your system administrator.`;
LoginConfig.loginLabel = 'Sign in to start your session';
LoginConfig.resetPasswordLabel = 'Please set a new Password for your account.';
LoginConfig.signInButtonText = 'Sign In';
LoginConfig.signInFailure = `Sorry, we were unable to process your request at this time. It's not your fault. Please try again later, or contact your system administrator.`;
LoginConfig.userNamePasswordFailure = 'Username or Password is not correct.';
LoginConfig.microsoftSignInFailureEmail = `Email not found in our system.  Pleace try again later, or contact your system administrator.`;
LoginConfig.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [LoginModuleConfigToken,] }, { type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LoginConfig, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [LoginModuleConfigToken]
            }, {
                type: Optional
            }] }]; }, null); })();

class RememberUserNameStorageService {
    constructor(storageService) {
        this.storageService = storageService;
        this.USER_NAME_KEY = 'LOGIN_USER_NAME_KEY';
    }
    saveRememberUserName(userName) {
        const cookieExpiration = new Date();
        // save refresh token in cookie for 1 month on each refresh
        // auth token will expire before cookie does but refresh will not
        cookieExpiration.setDate(cookieExpiration.getDate() + 30);
        this.storageService.set(this.USER_NAME_KEY, userName, { expires: cookieExpiration });
    }
    getUserNameFromCookie() {
        return from(this.storageService.get(this.USER_NAME_KEY));
    }
    removeUserNameCookie() {
        this.storageService.remove(this.USER_NAME_KEY);
    }
}
RememberUserNameStorageService.ɵfac = function RememberUserNameStorageService_Factory(t) { return new (t || RememberUserNameStorageService)(ɵngcc0.ɵɵinject(ɵngcc1.StorageService)); };
RememberUserNameStorageService.ɵprov = ɵɵdefineInjectable({ factory: function RememberUserNameStorageService_Factory() { return new RememberUserNameStorageService(ɵɵinject(StorageService)); }, token: RememberUserNameStorageService, providedIn: "root" });
RememberUserNameStorageService.ctorParameters = () => [
    { type: StorageService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RememberUserNameStorageService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.StorageService }]; }, null); })();

class LoginComponent {
    constructor(injector) {
        this.returnUrl = '';
        this.authService = injector.get(AuthService);
        this.router = injector.get(Router);
        this.notificationsService = injector.get(NotificationsService);
        this.environmentService = injector.get(EnvironmentService);
        this.config = injector.get(LoginConfig);
        this.pageTitlesService = injector.get(PageTitlesService);
        this.activatedRoute = injector.get(ActivatedRoute);
        this.rememberUserNameStorageService = injector.get(RememberUserNameStorageService);
        this.logoFull = this.config.useAssetsFolderForImages
            ? `${this.environmentService.config.assetsPath}logo-full.png`
            : `${this.environmentService.config.imgPath}logo-full.png`;
    }
    get hasGoogleAuthConfig() {
        return this.config.googleAuthConfig ? true : false;
    }
    get hasMicrosoftAuthConfig() {
        return this.config.microsoftAuthConfig ? true : false;
    }
    get rememberOption() {
        return this.config.rememberFeature.rememberOptions;
    }
    ngOnInit() {
        // appReady determines if an authenticated connection has been made.
        // While it's waiting it shows a loading icon.  When appReady has a
        // value the loading icon is hidden.  We always want this to be true
        // when you are on the login page.  Because you aren't authed!
        if (this.authService.appReady && !this.authService.appReady.getValue()) {
            this.authService.appReady.next(true);
        }
        this.createForm();
        this.setPageTitle();
        this.returnUrl = this.activatedRoute.snapshot.queryParams[MtAuthGuard.Return_Url_QueryParam];
    }
    setPageTitle() {
        this.pageTitlesService.setPageTitle('Login');
    }
    createForm() {
        this.rememberUserNameStorageService.getUserNameFromCookie().subscribe((remember) => {
            if (!this.loginForm) {
                this.loginForm = new FormGroup({});
            }
            this.loginForm.addControl('password', new FormControl(''));
            this.loginForm.addControl('username', new FormControl(remember || '', Validators.required));
            this.loginForm.addControl('rememberMe', new FormControl(false, Validators.required));
            this.loginForm.addControl('rememberUserName', new FormControl(remember ? true : false, Validators.required));
        });
    }
    showUsernameRequiredError() {
        const control = this.loginForm.get('username');
        return control.touched && control.hasError('required');
    }
    showPasswordRequiredError() {
        const control = this.loginForm.get('password');
        return control.touched && control.hasError('required');
    }
    onLogin() {
        if (this.loginForm.valid) {
            const values = this.loginForm.value;
            this.authService.login(values.username, values.password, values.rememberMe).subscribe((() => {
                if (values.rememberUserName) {
                    this.rememberUserNameStorageService.saveRememberUserName(values.username);
                }
                else {
                    this.rememberUserNameStorageService.removeUserNameCookie();
                }
                if (this.returnUrl) {
                    this.router.navigateByUrl(this.returnUrl);
                }
                else {
                    this.router.navigate(['/home']);
                }
            }).bind(this), (errorResponse) => {
                if (errorResponse.status === 418) {
                    if (errorResponse.error === 'DomainLoginEmailSent') {
                        this.notificationsService.success('A login link has been emailed to you');
                    }
                    else {
                        this.notificationsService.error(this.config.messageOverrides.userNamePasswordFailure);
                    }
                }
                else if (errorResponse.status === 403) {
                    if (errorResponse.error && typeof errorResponse.error === 'string') {
                        // if error message (i.e. "account is locked") then display it
                        this.notificationsService.error(errorResponse.error);
                    }
                    else {
                        // else rethrow the error
                        return throwError(errorResponse);
                    }
                }
            });
        }
        else {
            markAllFormFieldsAsTouched(this.loginForm);
        }
    }
}
LoginComponent.ɵfac = function LoginComponent_Factory(t) { return new (t || LoginComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
LoginComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LoginComponent, selectors: [["app-login"]], decls: 20, vars: 5, consts: [[1, "login-box"], ["alt", "Logo", 1, "logo-img", 3, "src"], [1, "login-box-body"], [1, "login-box-msg"], [4, "ngIf"], [1, "text-center", "third-party-buttons"], [3, "formGroup", "submit", 4, "ngIf"], [4, "ngFor", "ngForOf"], [3, "formGroup", "submit"], [1, "form-group", "has-feedback"], ["type", "text", "autofocus", "", "placeholder", "Username", "formControlName", "username", 1, "form-control"], [1, "fa", "fa-user", "form-control-feedback"], ["class", "small errortext", 3, "position", 4, "ngIf"], ["type", "password", "autocomplete", "off", "placeholder", "Password", "formControlName", "password", 1, "form-control"], ["Password", ""], [1, "fa", "fa-lock", "form-control-feedback"], [1, "padded", "block-parent"], [1, "form-check", 3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], ["type", "submit", 1, "btn", "btn-primary", "btn-flat", "inline-block", "block-right", 3, "disabled"], [1, "small", "errortext"], ["type", "checkbox", "id", "rememberMe", "formControlName", "rememberMe", 1, "form-check-input"], ["for", "rememberMe", 1, "form-check-label"], ["type", "checkbox", "id", "rememberUserName", "formControlName", "rememberUserName", 1, "form-check-input"], ["for", "rememberUserName", 1, "form-check-label"], [2, "cursor", "pointer", 3, "innerHtml", "routerLink"], [3, "config"]], template: function LoginComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelement(2, "img", 1);
        ɵngcc0.ɵɵtext(3, "\n    ");
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵtext(5, "\n        ");
        ɵngcc0.ɵɵelementStart(6, "p", 3);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(8, "\n        ");
        ɵngcc0.ɵɵtemplate(9, LoginComponent_div_9_Template, 6, 2, "div", 4);
        ɵngcc0.ɵɵtext(10, "\n        ");
        ɵngcc0.ɵɵelementStart(11, "div", 5);
        ɵngcc0.ɵɵtext(12, "\n            ");
        ɵngcc0.ɵɵtemplate(13, LoginComponent_div_13_Template, 6, 1, "div", 4);
        ɵngcc0.ɵɵtext(14, "\n            ");
        ɵngcc0.ɵɵtemplate(15, LoginComponent_div_15_Template, 6, 1, "div", 4);
        ɵngcc0.ɵɵtext(16, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(17, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(18, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(19, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.logoFull, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.config.messageOverrides.loginLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.config.hideRegularSignIn);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasGoogleAuthConfig);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasMicrosoftAuthConfig);
    } }, directives: function () { return [ɵngcc2.NgIf, ɵngcc2.NgForOf, ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase, ɵngcc2.NgSwitchDefault, ɵngcc3.CheckboxControlValueAccessor, ɵngcc4.RouterLink, GoogleLoginComponent, MsLoginComponent]; }, encapsulation: 2 });
LoginComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LoginComponent, [{
        type: Component,
        args: [{
                selector: 'app-login',
                template: "<div class=\"login-box\">\n    <img class=\"logo-img\" src=\"{{ logoFull }}\" alt=\"Logo\" />\n    <div class=\"login-box-body\">\n        <p class=\"login-box-msg\">{{ config.messageOverrides.loginLabel }}</p>\n        <div *ngIf=\"!config.hideRegularSignIn\">\n            <form *ngIf=\"loginForm\" [formGroup]=\"loginForm\" (submit)=\"onLogin()\">\n                <div class=\"form-group has-feedback\" [class.has-error]=\"showUsernameRequiredError()\">\n                    <input type=\"text\" autofocus class=\"form-control\" placeholder=\"Username\" formControlName=\"username\" />\n                    <span class=\"fa fa-user form-control-feedback\"></span>\n                    <div *ngIf=\"showUsernameRequiredError()\" class=\"small errortext\" [style.position]=\"'absolute'\">Username is required</div>\n                </div>\n                <div class=\"form-group has-feedback\" [class.has-error]=\"showPasswordRequiredError()\">\n                    <input #Password type=\"password\" autocomplete=\"off\" class=\"form-control\" placeholder=\"Password\" formControlName=\"password\" />\n                    <span class=\"fa fa-lock form-control-feedback\"></span>\n                    <div *ngIf=\"showPasswordRequiredError()\" class=\"small errortext\" [style.position]=\"'absolute'\">Password is required</div>\n                </div>\n                <div class=\"padded block-parent\">\n                    <div [ngSwitch]=\"rememberOption\" class=\"form-check\">\n                        <div *ngSwitchCase=\"'rememberMe'\">\n                            <input type=\"checkbox\" id=\"rememberMe\" class=\"form-check-input\" formControlName=\"rememberMe\" />\n                            <label class=\"form-check-label\" for=\"rememberMe\"> Remember Me</label>\n                        </div>\n                        <div *ngSwitchCase=\"'userName'\">\n                            <input type=\"checkbox\" id=\"rememberUserName\" class=\"form-check-input\" formControlName=\"rememberUserName\" />\n                            <label class=\"form-check-label\" for=\"rememberUserName\"> Remember My Username</label>\n                        </div>\n                        <div *ngSwitchDefault></div>\n                    </div>\n                    <button [disabled]=\"!loginForm.valid\" type=\"submit\" class=\"btn btn-primary btn-flat inline-block block-right\">\n                        {{ config.messageOverrides.signInButtonText }}\n                    </button>\n                </div>\n            </form>\n\n            <ng-container *ngFor=\"let link of config.loginComponentLinks\">\n                <span style=\"cursor: pointer\" [innerHtml]=\"link.linkHtml\" [routerLink]=\"link.routerLinkPath\"></span><br />\n            </ng-container>\n        </div>\n        <div class=\"text-center third-party-buttons\">\n            <div *ngIf=\"hasGoogleAuthConfig\">\n                <br />\n                <app-google-login [config]=\"config\"></app-google-login>\n            </div>\n            <div *ngIf=\"hasMicrosoftAuthConfig\">\n                <br />\n                <app-ms-login [config]=\"config\"></app-ms-login>\n            </div>\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class LoginService {
    constructor(cookieService, authService) {
        this.cookieService = cookieService;
        this.authService = authService;
        this._googleUserCookieKey = 'breck-google-user-cookie';
        this.signedInGoogleUser = new BehaviorSubject(null);
        this.initialize();
    }
    initialize() {
        // set signedInGoogleUser from cookie
        const googleCookieValue = this.cookieService.get(this._googleUserCookieKey);
        if (googleCookieValue) {
            this.signedInGoogleUser.next(JSON.parse(googleCookieValue));
        }
        // watch authService for currentUser
        this.authService.currentUser.subscribe((user) => {
            // if user is empty or has user Id of 0, then that is a logout
            if (!(user === null || user === void 0 ? void 0 : user.Id)) {
                // so if signedInGoogleUser is set, we need to clear it
                if (this.signedInGoogleUser.getValue()) {
                    this.signedInGoogleUser.next(null);
                }
            }
        });
        this.signedInGoogleUser.subscribe((googleUser) => {
            this.handleGoogleUserCookie(googleUser);
        });
    }
    handleGoogleUserCookie(googleUser) {
        if (googleUser) {
            this.cookieService.put(this._googleUserCookieKey, JSON.stringify(googleUser));
        }
        else {
            this.cookieService.remove(this._googleUserCookieKey);
        }
    }
}
LoginService.ɵfac = function LoginService_Factory(t) { return new (t || LoginService)(ɵngcc0.ɵɵinject(ɵngcc5.CookieService), ɵngcc0.ɵɵinject(ɵngcc6.AuthService)); };
LoginService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: LoginService, factory: LoginService.ɵfac });
LoginService.ctorParameters = () => [
    { type: CookieService },
    { type: AuthService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LoginService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc5.CookieService }, { type: ɵngcc6.AuthService }]; }, null); })();

class GoogleLoginComponent {
    constructor(injector, renderer2) {
        this.renderer2 = renderer2;
        this.authService = injector.get(AuthService);
        this.router = injector.get(Router);
        this.notificationsService = injector.get(NotificationsService);
        this.document = injector.get(DOCUMENT);
        this.ngZone = injector.get(NgZone);
        this.loginService = injector.get(LoginService);
        this.route = injector.get(ActivatedRoute);
    }
    ngOnInit() {
        this.getGoogleScripts();
        this.returnUrl = this.route.snapshot.queryParams[MtAuthGuard.Return_Url_QueryParam];
    }
    getGoogleScripts() {
        if (!this.config.googleAuthConfig.googleApiKey) {
            throw 'googleAuthConfig is missing the googleApiKey';
        }
        // shoot google api script tags onto page
        let s = this.renderer2.createElement('script');
        s.src = 'https://apis.google.com/js/platform.js';
        s.async = true;
        s.defer = true;
        this.renderer2.appendChild(this.document.body, s);
        s = this.renderer2.createElement('script');
        s.src = 'https://apis.google.com/js/api.js';
        s.async = true;
        s.defer = true;
        this.renderer2.appendChild(this.document.body, s);
    }
    ngAfterViewInit() {
        setTimeout(() => this.setupGoogleSignIn(), 1000);
    }
    setupGoogleSignIn() {
        gapi.load('auth2', () => {
            this.auth2 = gapi.auth2.init({
                client_id: this.config.googleAuthConfig.googleApiKey,
            });
            this.auth2.attachClickHandler(document.getElementById('googleSignInButton'), {}, this.onGoogleSignIn.bind(this), this.onGoogleSignInFailure.bind(this));
        });
    }
    onGoogleSignIn(googleUser) {
        const profile = googleUser.getBasicProfile();
        const googleProfile = {
            email: profile.getEmail(),
            familyName: profile.getFamilyName(),
            givenName: profile.getGivenName(),
            id: profile.getId(),
            imageUrl: profile.getImageUrl(),
            name: profile.getName(),
        };
        this.ngZone.run(() => {
            const token = googleUser.getAuthResponse().id_token;
            this.handleGoogleSignIn(googleProfile, token);
        });
        this.loginService.signedInGoogleUser.next(googleProfile);
    }
    handleGoogleSignIn(googleUser, token) {
        const googleLoginObject = {
            email: googleUser.email,
            firstName: googleUser.givenName,
            lastName: googleUser.familyName,
            token: token,
        };
        this.authService.googleLogin(googleLoginObject).subscribe((successResponse) => {
            // this is a workaround to a known issue
            // https://github.com/angular/angular/issues/18254
            if (this.returnUrl) {
                this.router.navigateByUrl(this.returnUrl);
            }
            else {
                this.router.navigate(['/home']);
            }
        }, (errorResponse) => {
            if (errorResponse.status === 418) {
                this.notificationsService.error(this.config.messageOverrides.googleSignInFailureEmail);
            }
            else {
                this.notificationsService.error(this.config.messageOverrides.googleSignInFailure);
            }
        });
    }
    onGoogleSignInFailure() { }
}
GoogleLoginComponent.ɵfac = function GoogleLoginComponent_Factory(t) { return new (t || GoogleLoginComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
GoogleLoginComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: GoogleLoginComponent, selectors: [["app-google-login"]], inputs: { config: "config" }, decls: 4, vars: 0, consts: [["id", "googleSignInButton", "formnovalidate", "", 1, "btn", "btn-default"], [1, "fa", "fa-google", "fa-lg"]], template: function GoogleLoginComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵelement(1, "i", 1);
        ɵngcc0.ɵɵtext(2, "Sign in with Google");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(3, "\n");
    } }, styles: [".fa-google[_ngcontent-%COMP%]{padding-right:10px}button[_ngcontent-%COMP%]{width:200px}"] });
GoogleLoginComponent.ctorParameters = () => [
    { type: Injector },
    { type: Renderer2 }
];
GoogleLoginComponent.propDecorators = {
    config: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GoogleLoginComponent, [{
        type: Component,
        args: [{
                selector: 'app-google-login',
                template: "<button id=\"googleSignInButton\" class=\"btn btn-default\" formnovalidate><i class=\"fa fa-google fa-lg\"></i>Sign in with Google</button>\n",
                styles: [".fa-google{padding-right:10px}button{width:200px}"]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: ɵngcc0.Renderer2 }]; }, { config: [{
            type: Input
        }] }); })();

class MsLoginComponent {
    constructor(injector) {
        this.authService = injector.get(AuthService);
        this.router = injector.get(Router);
        this.route = injector.get(ActivatedRoute);
        this.microsoftService = injector.get(MsalService);
        this.notificationService = injector.get(NotificationsService);
    }
    ngOnInit() {
        this.returnUrl = this.route.snapshot.queryParams[MtAuthGuard.Return_Url_QueryParam];
    }
    microsoftSignIn() {
        this.microsoftService
            .loginPopup({ scopes: this.config.microsoftAuthConfig.additionalScopes })
            .subscribe(this.handleMicrosoftSignIn.bind(this));
    }
    handleMicrosoftSignIn(authResponse) {
        this.authService.microsoftLogin(authResponse).subscribe((resp) => {
            if (this.returnUrl) {
                this.router.navigateByUrl(this.returnUrl);
            }
            else {
                this.router.navigate(['/home']);
            }
        }, (errorResponse) => {
            if (errorResponse.status === 418) {
                this.notificationService.error(this.config.messageOverrides.microsoftSignInFailureEmail);
            }
            else {
                this.notificationService.error(this.config.messageOverrides.microsoftSignInFailure);
            }
        });
    }
}
MsLoginComponent.ɵfac = function MsLoginComponent_Factory(t) { return new (t || MsLoginComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
MsLoginComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MsLoginComponent, selectors: [["app-ms-login"]], inputs: { config: "config" }, decls: 4, vars: 0, consts: [["formnovalidate", "", 1, "btn", "btn-default", 3, "click"], [1, "fa", "fa-windows", "fa-lg"]], template: function MsLoginComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function MsLoginComponent_Template_button_click_0_listener() { return ctx.microsoftSignIn(); });
        ɵngcc0.ɵɵelement(1, "i", 1);
        ɵngcc0.ɵɵtext(2, "Sign in with Microsoft");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(3, "\n");
    } }, styles: ["i[_ngcontent-%COMP%]{margin-right:.5em}button[_ngcontent-%COMP%]{width:200px}"] });
MsLoginComponent.ctorParameters = () => [
    { type: Injector }
];
MsLoginComponent.propDecorators = {
    config: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MsLoginComponent, [{
        type: Component,
        args: [{
                selector: 'app-ms-login',
                template: "<button class=\"btn btn-default\" formnovalidate (click)=\"microsoftSignIn()\"><i class=\"fa fa-windows fa-lg\"></i>Sign in with Microsoft</button>\n",
                styles: ["i{margin-right:.5em}button{width:200px}"]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, { config: [{
            type: Input
        }] }); })();

class ForgotPasswordComponent {
    constructor(injector) {
        this.forgotPasswordForm = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.email]),
        });
        this.authService = injector.get(AuthService);
        this.notificationsService = injector.get(NotificationsService);
        this.environmentService = injector.get(EnvironmentService);
        this.config = injector.get(LoginConfig);
        this.pageTitlesService = injector.get(PageTitlesService);
        this.logoFull = this.config.useAssetsFolderForImages
            ? `${this.environmentService.config.assetsPath}logo-full.png`
            : `${this.environmentService.config.imgPath}logo-full.png`;
    }
    ngOnInit() {
        // appReady determines if an authenticated connection has been made.
        // While it's waiting it shows a loading icon.  When appReady has a
        // value the loading icon is hidden.  We always want this to be true
        // when you are on the login page.  Because you aren't authed!
        if (this.authService.appReady && !this.authService.appReady.getValue()) {
            this.authService.appReady.next(true);
        }
        this.setPageTitle();
    }
    setPageTitle() {
        this.pageTitlesService.setPageTitle('Forgot Password');
    }
    emailHasError() {
        const control = this.forgotPasswordForm.get('email');
        return control.errors && (control.touched || control.errors.maxlength);
    }
    showEmailRequiredError() {
        const control = this.forgotPasswordForm.get('email');
        return control.touched && control.hasError('required');
    }
    showEmailInvalidError() {
        const control = this.forgotPasswordForm.get('email');
        return control.touched && control.hasError('email');
    }
    onLogin() {
        if (this.forgotPasswordForm.valid) {
            const values = this.forgotPasswordForm.value;
            this.authService.forgot(values.email).subscribe((success) => {
                this.notificationsService.success(this.config.messageOverrides.forgotPasswordSuccess);
            }, (error) => this.notificationsService.error(this.config.messageOverrides.forgotPasswordFailure));
        }
        else {
            markAllFormFieldsAsTouched(this.forgotPasswordForm);
        }
    }
}
ForgotPasswordComponent.ɵfac = function ForgotPasswordComponent_Factory(t) { return new (t || ForgotPasswordComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
ForgotPasswordComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ForgotPasswordComponent, selectors: [["app-forgot-password"]], decls: 34, vars: 8, consts: [[1, "login-box"], ["alt", "Logo", 1, "logo-img", 3, "src"], [1, "login-box-body"], [1, "login-box-msg"], [3, "formGroup", "submit"], [1, "form-group", "has-feedback"], ["type", "text", "autofocus", "", "placeholder", "example@domain.com", "formControlName", "email", 1, "form-control"], [1, "fa", "fa-user", "form-control-feedback"], ["class", "small errortext", 3, "position", 4, "ngIf"], [1, "padded", "block-parent"], ["type", "button", "routerLink", "/login", 1, "btn", "btn-default", "btn-flat", "inline-block", "block-left"], ["type", "submit", 1, "btn", "btn-primary", "btn-flat", "inline-block", "block-right", 3, "disabled"], [1, "small", "errortext"]], template: function ForgotPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelement(2, "img", 1);
        ɵngcc0.ɵɵtext(3, "\n    ");
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵtext(5, "\n        ");
        ɵngcc0.ɵɵelementStart(6, "p", 3);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(8, "\n        ");
        ɵngcc0.ɵɵelementStart(9, "form", 4);
        ɵngcc0.ɵɵlistener("submit", function ForgotPasswordComponent_Template_form_submit_9_listener() { return ctx.onLogin(); });
        ɵngcc0.ɵɵtext(10, "\n            ");
        ɵngcc0.ɵɵelementStart(11, "div", 5);
        ɵngcc0.ɵɵtext(12, "\n                ");
        ɵngcc0.ɵɵelement(13, "input", 6);
        ɵngcc0.ɵɵtext(14, "\n                ");
        ɵngcc0.ɵɵelement(15, "span", 7);
        ɵngcc0.ɵɵtext(16, "\n                ");
        ɵngcc0.ɵɵtemplate(17, ForgotPasswordComponent_div_17_Template, 2, 2, "div", 8);
        ɵngcc0.ɵɵtext(18, "\n                ");
        ɵngcc0.ɵɵtemplate(19, ForgotPasswordComponent_div_19_Template, 2, 2, "div", 8);
        ɵngcc0.ɵɵtext(20, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(21, "\n            ");
        ɵngcc0.ɵɵelementStart(22, "div", 9);
        ɵngcc0.ɵɵtext(23, "\n                ");
        ɵngcc0.ɵɵelementStart(24, "button", 10);
        ɵngcc0.ɵɵtext(25, "Back");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(26, "\n                ");
        ɵngcc0.ɵɵelementStart(27, "button", 11);
        ɵngcc0.ɵɵtext(28, "Submit");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(29, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(30, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(31, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(32, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(33, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.logoFull, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.config.messageOverrides.forgotPasswordLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formGroup", ctx.forgotPasswordForm);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("has-error", ctx.emailHasError());
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showEmailRequiredError());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showEmailInvalidError());
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("disabled", !ctx.forgotPasswordForm.valid);
    } }, directives: [ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc2.NgIf, ɵngcc4.RouterLink], encapsulation: 2 });
ForgotPasswordComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ForgotPasswordComponent, [{
        type: Component,
        args: [{
                selector: 'app-forgot-password',
                template: "<div class=\"login-box\">\n    <img class=\"logo-img\" src=\"{{ logoFull }}\" alt=\"Logo\" />\n    <div class=\"login-box-body\">\n        <p class=\"login-box-msg\">{{ config.messageOverrides.forgotPasswordLabel }}</p>\n        <form [formGroup]=\"forgotPasswordForm\" (submit)=\"onLogin()\">\n            <div class=\"form-group has-feedback\" [class.has-error]=\"emailHasError()\">\n                <input type=\"text\" autofocus class=\"form-control\" placeholder=\"example@domain.com\" formControlName=\"email\" />\n                <span class=\"fa fa-user form-control-feedback\"></span>\n                <div *ngIf=\"showEmailRequiredError()\" class=\"small errortext\" [style.position]=\"'block'\">Email is required</div>\n                <div *ngIf=\"showEmailInvalidError()\" class=\"small errortext\" [style.position]=\"'block'\">\n                    Invalid email address. Valid e-mail can contain only letters, numbers and '@'\n                </div>\n            </div>\n            <div class=\"padded block-parent\">\n                <button type=\"button\" routerLink=\"/login\" class=\"btn btn-default btn-flat inline-block block-left\">Back</button>\n                <button [disabled]=\"!forgotPasswordForm.valid\" type=\"submit\" class=\"btn btn-primary btn-flat inline-block block-right\">Submit</button>\n            </div>\n        </form>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class ResetPasswordComponent {
    constructor(injector) {
        this.resetPasswordForm = new FormGroup({});
        this.doubleClickIsDisabled = false;
        this.authService = injector.get(AuthService);
        this.router = injector.get(Router);
        this.route = injector.get(ActivatedRoute);
        this.notificationsService = injector.get(NotificationsService);
        this.environmentService = injector.get(EnvironmentService);
        this.config = injector.get(LoginConfig);
        this.pageTitlesService = injector.get(PageTitlesService);
        this.logoFull = this.config.useAssetsFolderForImages
            ? `${this.environmentService.config.assetsPath}logo-full.png`
            : `${this.environmentService.config.imgPath}logo-full.png`;
        this.resetPasswordForm.addControl('Password', new FormControl('', [Validators.required, Validators.pattern(this.config.passwordPattern)]));
        this.resetPasswordForm.addControl('ConfirmPassword', new FormControl('', [Validators.required, Validators.pattern(this.config.passwordPattern)]));
    }
    ngOnInit() {
        // appReady determines if an authenticated connection has been made.
        // While it's waiting it shows a loading icon.  When appReady has a
        // value the loading icon is hidden.  We always want this to be true
        // when you are on the login page.  Because you aren't authed!
        if (this.authService.appReady && !this.authService.appReady.getValue()) {
            this.authService.appReady.next(true);
        }
        const queryParams = this.route.snapshot.queryParams;
        this.resetKey = queryParams.resetKey;
        this.userId = +queryParams.userId;
        this.setPageTitle();
    }
    setPageTitle() {
        this.pageTitlesService.setPageTitle('Reset Password');
    }
    passwordHasError() {
        const control = this.resetPasswordForm.get('Password');
        return control.errors && (control.touched || control.errors.maxlength);
    }
    showPasswordRequiredError() {
        const control = this.resetPasswordForm.get('Password');
        return control.touched && control.hasError('required');
    }
    showConfirmPasswordRequiredError() {
        const control = this.resetPasswordForm.get('ConfirmPassword');
        return control.touched && control.hasError('required');
    }
    showPasswordMustMatchError() {
        const control = this.resetPasswordForm.get('Password');
        const controlValue = control.value;
        const confirmControl = this.resetPasswordForm.get('ConfirmPassword');
        const confirmControlValue = confirmControl.value;
        return control.touched && confirmControl.touched && controlValue.length && confirmControlValue.length && controlValue !== confirmControlValue;
    }
    hasRegexError() {
        var _a;
        let answer = false;
        let passwordControl = this.resetPasswordForm.controls.Password;
        if ((_a = passwordControl.errors) === null || _a === void 0 ? void 0 : _a.pattern) {
            answer = true;
            passwordControl.setErrors({ pattern: true });
        }
        return answer;
    }
    onSubmit() {
        const form = this.resetPasswordForm;
        if (this.authService.matchPassword(form, null)) {
            if (form.valid) {
                this.authService
                    .resetPassword(this.userId, form.value.Password, form.value.ConfirmPassword, this.resetKey)
                    .pipe(finalize(() => (this.doubleClickIsDisabled = false)))
                    .subscribe((answer) => {
                    this.success();
                    this.router.navigate(['/home']);
                }, (error) => {
                    if (error.status === 418) {
                        this.notificationsService.error(LoginConfig.signInFailure);
                    }
                    else if (error.status === 400) {
                        // TODO: Can we just inject the error service?
                        if (error.error) {
                            this.error(error.error.ModelState.Service);
                        }
                        else {
                            this.error('Something went wrong, Please generate a new reset email');
                            console.error(`Oops something went wrong!
                                - Probably the key has been used or expired.
                                - Or you did something you weren't supposed to do.
                                - Your best bet is to just generate a new email.`);
                        }
                    }
                });
            }
            else {
                markAllFormFieldsAsTouched(form);
                this.enableDoubleClick();
            }
        }
        else {
            this.error('Passwords do not match');
            this.enableDoubleClick();
        }
    }
    enableDoubleClick() {
        setTimeout(() => {
            this.doubleClickIsDisabled = false;
        });
    }
    error(msg) {
        if (!msg) {
            this.notificationsService.error('Save Failed');
        }
        else {
            this.notificationsService.error(msg);
        }
    }
    success() {
        this.notificationsService.success('Password Updated Successfully');
    }
}
ResetPasswordComponent.ɵfac = function ResetPasswordComponent_Factory(t) { return new (t || ResetPasswordComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
ResetPasswordComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ResetPasswordComponent, selectors: [["app-reset-password"]], decls: 53, vars: 13, consts: [[1, "login-box"], ["alt", "Logo", 1, "logo-img", 3, "src"], [1, "login-box-body"], [1, "login-box-msg"], [3, "formGroup", "ngSubmit"], [1, "form-group", "has-feedback"], ["aria-hidden", "true", "data-toggle", "tooltip", "data-html", "true", "data-placement", "right", 1, "fa", "fa-info-circle", 3, "title"], ["type", "password", "autofocus", "", "autocomplete", "off", "placeholder", "Password", "formControlName", "Password", 1, "form-control"], ["Password", ""], [1, "fa", "fa-lock", "form-control-feedback"], ["class", "small errortext", 3, "position", 4, "ngIf"], ["class", "small errortext", "id", "failedPatternMessage", 3, "position", 4, "ngIf"], ["type", "password", "autocomplete", "off", "placeholder", "Confirm Password", "formControlName", "ConfirmPassword", 1, "form-control"], ["PasswordConfirm", ""], ["type", "submit", "mt-doubleClickDisabled", "", "Class", "btn btn-flat btn-success", 3, "doubleClickIsDisabled", "doubleClickIsDisabledChange"], ["routerLink", "/login", 1, "btn", "btn-default", "pull-right"], [1, "small", "errortext"], ["id", "failedPatternMessage", 1, "small", "errortext"]], template: function ResetPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelement(2, "img", 1);
        ɵngcc0.ɵɵtext(3, "\n    ");
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵtext(5, "\n        ");
        ɵngcc0.ɵɵelementStart(6, "p", 3);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(8, "\n        ");
        ɵngcc0.ɵɵelementStart(9, "form", 4);
        ɵngcc0.ɵɵlistener("ngSubmit", function ResetPasswordComponent_Template_form_ngSubmit_9_listener() { return ctx.onSubmit(); });
        ɵngcc0.ɵɵtext(10, "\n            ");
        ɵngcc0.ɵɵelementStart(11, "div", 5);
        ɵngcc0.ɵɵtext(12, "\n                ");
        ɵngcc0.ɵɵelementStart(13, "label");
        ɵngcc0.ɵɵtext(14, "New Password");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(15, "i", 6);
        ɵngcc0.ɵɵtext(16, "\n                ");
        ɵngcc0.ɵɵelement(17, "input", 7, 8);
        ɵngcc0.ɵɵtext(19, "\n                ");
        ɵngcc0.ɵɵelement(20, "span", 9);
        ɵngcc0.ɵɵtext(21, "\n                ");
        ɵngcc0.ɵɵtemplate(22, ResetPasswordComponent_div_22_Template, 2, 2, "div", 10);
        ɵngcc0.ɵɵtext(23, "\n                ");
        ɵngcc0.ɵɵtemplate(24, ResetPasswordComponent_div_24_Template, 2, 2, "div", 10);
        ɵngcc0.ɵɵtext(25, "\n                ");
        ɵngcc0.ɵɵtemplate(26, ResetPasswordComponent_div_26_Template, 2, 3, "div", 11);
        ɵngcc0.ɵɵtext(27, "\n                ");
        ɵngcc0.ɵɵelementStart(28, "label");
        ɵngcc0.ɵɵtext(29, "Confirm New Password");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(30, "\n                ");
        ɵngcc0.ɵɵelementStart(31, "div", 5);
        ɵngcc0.ɵɵtext(32, "\n                    ");
        ɵngcc0.ɵɵelement(33, "input", 12, 13);
        ɵngcc0.ɵɵtext(35, "\n                    ");
        ɵngcc0.ɵɵelement(36, "span", 9);
        ɵngcc0.ɵɵtext(37, "\n                    ");
        ɵngcc0.ɵɵtemplate(38, ResetPasswordComponent_div_38_Template, 2, 2, "div", 10);
        ɵngcc0.ɵɵtext(39, "\n                ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(40, "\n                ");
        ɵngcc0.ɵɵelementStart(41, "button", 14);
        ɵngcc0.ɵɵlistener("doubleClickIsDisabledChange", function ResetPasswordComponent_Template_button_doubleClickIsDisabledChange_41_listener($event) { return ctx.doubleClickIsDisabled = $event; });
        ɵngcc0.ɵɵtext(42, "\n                    Save\n                ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(43, "\n                ");
        ɵngcc0.ɵɵelementStart(44, "a", 15);
        ɵngcc0.ɵɵtext(45, " Go Home ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(46, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(47, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(48, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(49, "\n    ");
        ɵngcc0.ɵɵtext(50, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(51, "\n");
        ɵngcc0.ɵɵtext(52, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.logoFull, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1("\n            ", ctx.config.messageOverrides.resetPasswordLabel, "\n        ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formGroup", ctx.resetPasswordForm);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("has-error", ctx.passwordHasError());
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("title", ctx.config.messageOverrides.failedPattern);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showPasswordRequiredError());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showPasswordMustMatchError());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasRegexError());
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵclassProp("has-error", ctx.showConfirmPasswordRequiredError());
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showConfirmPasswordRequiredError());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("doubleClickIsDisabled", ctx.doubleClickIsDisabled);
    } }, directives: [ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc2.NgIf, ɵngcc7.MtPreventDoubleClickDirective, ɵngcc4.RouterLinkWithHref], encapsulation: 2 });
ResetPasswordComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ResetPasswordComponent, [{
        type: Component,
        args: [{
                selector: 'app-reset-password',
                template: "<div class=\"login-box\">\n    <img class=\"logo-img\" src=\"{{ logoFull }}\" alt=\"Logo\" />\n    <div class=\"login-box-body\">\n        <p class=\"login-box-msg\">\n            {{ config.messageOverrides.resetPasswordLabel }}\n        </p>\n        <form [formGroup]=\"resetPasswordForm\" (ngSubmit)=\"onSubmit()\">\n            <div class=\"form-group has-feedback\" [class.has-error]=\"passwordHasError()\">\n                <label>New Password</label\n                ><i\n                    class=\"fa fa-info-circle\"\n                    aria-hidden=\"true\"\n                    data-toggle=\"tooltip\"\n                    data-html=\"true\"\n                    data-placement=\"right\"\n                    [title]=\"config.messageOverrides.failedPattern\"\n                ></i>\n                <input\n                    #Password\n                    type=\"password\"\n                    autofocus\n                    autocomplete=\"off\"\n                    class=\"form-control\"\n                    placeholder=\"Password\"\n                    formControlName=\"Password\"\n                />\n                <span class=\"fa fa-lock form-control-feedback\"></span>\n                <div *ngIf=\"showPasswordRequiredError()\" class=\"small errortext\" [style.position]=\"'block'\">Password is required</div>\n                <div *ngIf=\"showPasswordMustMatchError()\" class=\"small errortext\" [style.position]=\"'block'\">Passwords must match</div>\n                <div *ngIf=\"hasRegexError()\" class=\"small errortext\" [style.position]=\"'block'\" id=\"failedPatternMessage\">\n                    {{ config.messageOverrides.failedPattern }}\n                </div>\n                <label>Confirm New Password</label>\n                <div class=\"form-group has-feedback\" [class.has-error]=\"showConfirmPasswordRequiredError()\">\n                    <input\n                        #PasswordConfirm\n                        type=\"password\"\n                        autocomplete=\"off\"\n                        class=\"form-control\"\n                        placeholder=\"Confirm Password\"\n                        formControlName=\"ConfirmPassword\"\n                    />\n                    <span class=\"fa fa-lock form-control-feedback\"></span>\n                    <div *ngIf=\"showConfirmPasswordRequiredError()\" class=\"small errortext\" [style.position]=\"'block'\">\n                        Secondary Password is required\n                    </div>\n                </div>\n                <button type=\"submit\" mt-doubleClickDisabled [(doubleClickIsDisabled)]=\"doubleClickIsDisabled\" Class=\"btn btn-flat btn-success\">\n                    Save\n                </button>\n                <a routerLink=\"/login\" class=\"btn btn-default pull-right\"> Go Home </a>\n            </div>\n        </form>\n    </div>\n    <!-- /.login-box-body -->\n</div>\n<!-- /.login-box -->\n"
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class AdminAccessComponent {
    constructor(injector) {
        this.badKeyError = `Oops something went wrong!
    - Probably the key has been used or expired.
    - Or you did something you weren't supposed to do.
    - Your best bet is to just generate a new email.`;
        this.authService = injector.get(AuthService);
        this.router = injector.get(Router);
        this.route = injector.get(ActivatedRoute);
        this.notificationsService = injector.get(NotificationsService);
        this.pageTitlesService = injector.get(PageTitlesService);
    }
    ngOnInit() {
        this.route.queryParams.subscribe((params) => {
            this.resetKey = params.resetKey;
        });
        this.authService.adminAccess(this.resetKey).subscribe((answer) => {
            this.success();
            this.router.navigate(['/home']);
        }, (error) => {
            if (error.status === 418) {
                this.notificationsService.error('Access link is invalid');
                console.error(this.badKeyError);
            }
            else if (error.status === 400) {
                // TODO: Can we just inject the error service?
                if (error.error) {
                    this.error(error.error.ModelState.Service);
                }
                else {
                    this.error('Something went wrong, Please generate a new access email');
                    console.error(this.badKeyError);
                }
            }
        });
        this.setPageTitle();
    }
    setPageTitle() {
        this.pageTitlesService.setPageTitle('Admin Access');
    }
    error(msg) {
        if (!msg) {
            this.notificationsService.error('Save Failed');
        }
        else {
            this.notificationsService.error(msg);
        }
    }
    success() {
        this.notificationsService.success('Welcome Miles User!');
    }
}
AdminAccessComponent.ɵfac = function AdminAccessComponent_Factory(t) { return new (t || AdminAccessComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
AdminAccessComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AdminAccessComponent, selectors: [["app-admin-access"]], decls: 0, vars: 0, template: function AdminAccessComponent_Template(rf, ctx) { }, encapsulation: 2 });
AdminAccessComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AdminAccessComponent, [{
        type: Component,
        args: [{
                selector: 'app-admin-access',
                template: ""
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class LoginOldStyleComponent extends LoginComponent {
    constructor(injector) {
        super(injector);
        this.navService = injector.get(NavService);
    }
    ngOnInit() {
        super.ngOnInit();
        this.navService.setShowNav(false);
    }
    ngOnDestroy() {
        this.navService.setShowNav(true);
    }
}
LoginOldStyleComponent.ɵfac = function LoginOldStyleComponent_Factory(t) { return new (t || LoginOldStyleComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
LoginOldStyleComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LoginOldStyleComponent, selectors: [["app-login"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 20, vars: 5, consts: [[1, "login-box"], ["alt", "Logo", 1, "logo-img", 3, "src"], [1, "login-box-body"], [1, "login-box-msg"], [4, "ngIf"], [1, "text-center", "third-party-buttons"], [3, "formGroup", "submit", 4, "ngIf"], [4, "ngFor", "ngForOf"], [3, "formGroup", "submit"], [1, "form-group", "has-feedback"], ["type", "text", "autofocus", "", "placeholder", "Username", "formControlName", "username", 1, "form-control"], [1, "fa", "fa-user", "form-control-feedback"], ["class", "small errortext", 3, "position", 4, "ngIf"], ["type", "password", "autocomplete", "off", "placeholder", "Password", "formControlName", "password", 1, "form-control"], ["Password", ""], [1, "fa", "fa-lock", "form-control-feedback"], [1, "padded", "block-parent"], [1, "form-check", 3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], ["type", "submit", 1, "btn", "btn-primary", "btn-flat", "inline-block", "block-right", 3, "disabled"], [1, "small", "errortext"], ["type", "checkbox", "id", "rememberMe", "formControlName", "rememberMe", 1, "form-check-input"], ["for", "rememberMe", 1, "form-check-label"], ["type", "checkbox", "id", "rememberUserName", "formControlName", "rememberUserName", 1, "form-check-input"], ["for", "rememberUserName", 1, "form-check-label"], [2, "cursor", "pointer", 3, "innerHtml", "routerLink"], [3, "config"]], template: function LoginOldStyleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelement(2, "img", 1);
        ɵngcc0.ɵɵtext(3, "\n    ");
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵtext(5, "\n        ");
        ɵngcc0.ɵɵelementStart(6, "p", 3);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(8, "\n        ");
        ɵngcc0.ɵɵtemplate(9, LoginOldStyleComponent_div_9_Template, 6, 2, "div", 4);
        ɵngcc0.ɵɵtext(10, "\n        ");
        ɵngcc0.ɵɵelementStart(11, "div", 5);
        ɵngcc0.ɵɵtext(12, "\n            ");
        ɵngcc0.ɵɵtemplate(13, LoginOldStyleComponent_div_13_Template, 6, 1, "div", 4);
        ɵngcc0.ɵɵtext(14, "\n            ");
        ɵngcc0.ɵɵtemplate(15, LoginOldStyleComponent_div_15_Template, 6, 1, "div", 4);
        ɵngcc0.ɵɵtext(16, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(17, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(18, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(19, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.logoFull, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.config.messageOverrides.loginLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.config.hideRegularSignIn);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasGoogleAuthConfig);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasMicrosoftAuthConfig);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf, ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase, ɵngcc2.NgSwitchDefault, ɵngcc3.CheckboxControlValueAccessor, ɵngcc4.RouterLink, GoogleLoginComponent, MsLoginComponent], encapsulation: 2 });
LoginOldStyleComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LoginOldStyleComponent, [{
        type: Component,
        args: [{
                selector: 'app-login',
                template: "<div class=\"login-box\">\n    <img class=\"logo-img\" src=\"{{ logoFull }}\" alt=\"Logo\" />\n    <div class=\"login-box-body\">\n        <p class=\"login-box-msg\">{{ config.messageOverrides.loginLabel }}</p>\n        <div *ngIf=\"!config.hideRegularSignIn\">\n            <form *ngIf=\"loginForm\" [formGroup]=\"loginForm\" (submit)=\"onLogin()\">\n                <div class=\"form-group has-feedback\" [class.has-error]=\"showUsernameRequiredError()\">\n                    <input type=\"text\" autofocus class=\"form-control\" placeholder=\"Username\" formControlName=\"username\" />\n                    <span class=\"fa fa-user form-control-feedback\"></span>\n                    <div *ngIf=\"showUsernameRequiredError()\" class=\"small errortext\" [style.position]=\"'absolute'\">Username is required</div>\n                </div>\n                <div class=\"form-group has-feedback\" [class.has-error]=\"showPasswordRequiredError()\">\n                    <input #Password type=\"password\" autocomplete=\"off\" class=\"form-control\" placeholder=\"Password\" formControlName=\"password\" />\n                    <span class=\"fa fa-lock form-control-feedback\"></span>\n                    <div *ngIf=\"showPasswordRequiredError()\" class=\"small errortext\" [style.position]=\"'absolute'\">Password is required</div>\n                </div>\n                <div class=\"padded block-parent\">\n                    <div [ngSwitch]=\"rememberOption\" class=\"form-check\">\n                        <div *ngSwitchCase=\"'rememberMe'\">\n                            <input type=\"checkbox\" id=\"rememberMe\" class=\"form-check-input\" formControlName=\"rememberMe\" />\n                            <label class=\"form-check-label\" for=\"rememberMe\"> Remember Me</label>\n                        </div>\n                        <div *ngSwitchCase=\"'userName'\">\n                            <input type=\"checkbox\" id=\"rememberUserName\" class=\"form-check-input\" formControlName=\"rememberUserName\" />\n                            <label class=\"form-check-label\" for=\"rememberUserName\"> Remember My Username</label>\n                        </div>\n                        <div *ngSwitchDefault></div>\n                    </div>\n                    <button [disabled]=\"!loginForm.valid\" type=\"submit\" class=\"btn btn-primary btn-flat inline-block block-right\">\n                        {{ config.messageOverrides.signInButtonText }}\n                    </button>\n                </div>\n            </form>\n\n            <ng-container *ngFor=\"let link of config.loginComponentLinks\">\n                <span style=\"cursor: pointer\" [innerHtml]=\"link.linkHtml\" [routerLink]=\"link.routerLinkPath\"></span><br />\n            </ng-container>\n        </div>\n        <div class=\"text-center third-party-buttons\">\n            <div *ngIf=\"hasGoogleAuthConfig\">\n                <br />\n                <app-google-login [config]=\"config\"></app-google-login>\n            </div>\n            <div *ngIf=\"hasMicrosoftAuthConfig\">\n                <br />\n                <app-ms-login [config]=\"config\"></app-ms-login>\n            </div>\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class ForgotPasswordOldStyleComponent extends ForgotPasswordComponent {
    constructor(injector) {
        super(injector);
        this.navService = injector.get(NavService);
    }
    ngOnInit() {
        super.ngOnInit();
        this.navService.setShowNav(false);
    }
    ngOnDestroy() {
        this.navService.setShowNav(true);
    }
}
ForgotPasswordOldStyleComponent.ɵfac = function ForgotPasswordOldStyleComponent_Factory(t) { return new (t || ForgotPasswordOldStyleComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
ForgotPasswordOldStyleComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ForgotPasswordOldStyleComponent, selectors: [["app-forgot-password"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 34, vars: 8, consts: [[1, "login-box"], ["alt", "Logo", 1, "logo-img", 3, "src"], [1, "login-box-body"], [1, "login-box-msg"], [3, "formGroup", "submit"], [1, "form-group", "has-feedback"], ["type", "text", "autofocus", "", "placeholder", "example@domain.com", "formControlName", "email", 1, "form-control"], [1, "fa", "fa-user", "form-control-feedback"], ["class", "small errortext", 3, "position", 4, "ngIf"], [1, "padded", "block-parent"], ["type", "button", "routerLink", "/login", 1, "btn", "btn-default", "btn-flat", "inline-block", "block-left"], ["type", "submit", 1, "btn", "btn-primary", "btn-flat", "inline-block", "block-right", 3, "disabled"], [1, "small", "errortext"]], template: function ForgotPasswordOldStyleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelement(2, "img", 1);
        ɵngcc0.ɵɵtext(3, "\n    ");
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵtext(5, "\n        ");
        ɵngcc0.ɵɵelementStart(6, "p", 3);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(8, "\n        ");
        ɵngcc0.ɵɵelementStart(9, "form", 4);
        ɵngcc0.ɵɵlistener("submit", function ForgotPasswordOldStyleComponent_Template_form_submit_9_listener() { return ctx.onLogin(); });
        ɵngcc0.ɵɵtext(10, "\n            ");
        ɵngcc0.ɵɵelementStart(11, "div", 5);
        ɵngcc0.ɵɵtext(12, "\n                ");
        ɵngcc0.ɵɵelement(13, "input", 6);
        ɵngcc0.ɵɵtext(14, "\n                ");
        ɵngcc0.ɵɵelement(15, "span", 7);
        ɵngcc0.ɵɵtext(16, "\n                ");
        ɵngcc0.ɵɵtemplate(17, ForgotPasswordOldStyleComponent_div_17_Template, 2, 2, "div", 8);
        ɵngcc0.ɵɵtext(18, "\n                ");
        ɵngcc0.ɵɵtemplate(19, ForgotPasswordOldStyleComponent_div_19_Template, 2, 2, "div", 8);
        ɵngcc0.ɵɵtext(20, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(21, "\n            ");
        ɵngcc0.ɵɵelementStart(22, "div", 9);
        ɵngcc0.ɵɵtext(23, "\n                ");
        ɵngcc0.ɵɵelementStart(24, "button", 10);
        ɵngcc0.ɵɵtext(25, "Back");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(26, "\n                ");
        ɵngcc0.ɵɵelementStart(27, "button", 11);
        ɵngcc0.ɵɵtext(28, "Submit");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(29, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(30, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(31, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(32, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(33, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.logoFull, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.config.messageOverrides.forgotPasswordLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formGroup", ctx.forgotPasswordForm);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("has-error", ctx.emailHasError());
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showEmailRequiredError());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showEmailInvalidError());
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("disabled", !ctx.forgotPasswordForm.valid);
    } }, directives: [ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc2.NgIf, ɵngcc4.RouterLink], encapsulation: 2 });
ForgotPasswordOldStyleComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ForgotPasswordOldStyleComponent, [{
        type: Component,
        args: [{
                selector: 'app-forgot-password',
                template: "<div class=\"login-box\">\n    <img class=\"logo-img\" src=\"{{ logoFull }}\" alt=\"Logo\" />\n    <div class=\"login-box-body\">\n        <p class=\"login-box-msg\">{{ config.messageOverrides.forgotPasswordLabel }}</p>\n        <form [formGroup]=\"forgotPasswordForm\" (submit)=\"onLogin()\">\n            <div class=\"form-group has-feedback\" [class.has-error]=\"emailHasError()\">\n                <input type=\"text\" autofocus class=\"form-control\" placeholder=\"example@domain.com\" formControlName=\"email\" />\n                <span class=\"fa fa-user form-control-feedback\"></span>\n                <div *ngIf=\"showEmailRequiredError()\" class=\"small errortext\" [style.position]=\"'block'\">Email is required</div>\n                <div *ngIf=\"showEmailInvalidError()\" class=\"small errortext\" [style.position]=\"'block'\">\n                    Invalid email address. Valid e-mail can contain only letters, numbers and '@'\n                </div>\n            </div>\n            <div class=\"padded block-parent\">\n                <button type=\"button\" routerLink=\"/login\" class=\"btn btn-default btn-flat inline-block block-left\">Back</button>\n                <button [disabled]=\"!forgotPasswordForm.valid\" type=\"submit\" class=\"btn btn-primary btn-flat inline-block block-right\">Submit</button>\n            </div>\n        </form>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class ResetPasswordOldStyleComponent extends ResetPasswordComponent {
    constructor(injector) {
        super(injector);
        this.navService = injector.get(NavService);
    }
    ngOnInit() {
        super.ngOnInit();
        this.navService.setShowNav(false);
    }
    ngOnDestroy() {
        this.navService.setShowNav(true);
    }
}
ResetPasswordOldStyleComponent.ɵfac = function ResetPasswordOldStyleComponent_Factory(t) { return new (t || ResetPasswordOldStyleComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
ResetPasswordOldStyleComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ResetPasswordOldStyleComponent, selectors: [["app-reset-password"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 53, vars: 13, consts: [[1, "login-box"], ["alt", "Logo", 1, "logo-img", 3, "src"], [1, "login-box-body"], [1, "login-box-msg"], [3, "formGroup", "ngSubmit"], [1, "form-group", "has-feedback"], ["aria-hidden", "true", "data-toggle", "tooltip", "data-html", "true", "data-placement", "right", 1, "fa", "fa-info-circle", 3, "title"], ["type", "password", "autofocus", "", "autocomplete", "off", "placeholder", "Password", "formControlName", "Password", 1, "form-control"], ["Password", ""], [1, "fa", "fa-lock", "form-control-feedback"], ["class", "small errortext", 3, "position", 4, "ngIf"], ["class", "small errortext", "id", "failedPatternMessage", 3, "position", 4, "ngIf"], ["type", "password", "autocomplete", "off", "placeholder", "Confirm Password", "formControlName", "ConfirmPassword", 1, "form-control"], ["PasswordConfirm", ""], ["type", "submit", "mt-doubleClickDisabled", "", "Class", "btn btn-flat btn-success", 3, "doubleClickIsDisabled", "doubleClickIsDisabledChange"], ["routerLink", "/login", 1, "btn", "btn-default", "pull-right"], [1, "small", "errortext"], ["id", "failedPatternMessage", 1, "small", "errortext"]], template: function ResetPasswordOldStyleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelement(2, "img", 1);
        ɵngcc0.ɵɵtext(3, "\n    ");
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵtext(5, "\n        ");
        ɵngcc0.ɵɵelementStart(6, "p", 3);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(8, "\n        ");
        ɵngcc0.ɵɵelementStart(9, "form", 4);
        ɵngcc0.ɵɵlistener("ngSubmit", function ResetPasswordOldStyleComponent_Template_form_ngSubmit_9_listener() { return ctx.onSubmit(); });
        ɵngcc0.ɵɵtext(10, "\n            ");
        ɵngcc0.ɵɵelementStart(11, "div", 5);
        ɵngcc0.ɵɵtext(12, "\n                ");
        ɵngcc0.ɵɵelementStart(13, "label");
        ɵngcc0.ɵɵtext(14, "New Password");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(15, "i", 6);
        ɵngcc0.ɵɵtext(16, "\n                ");
        ɵngcc0.ɵɵelement(17, "input", 7, 8);
        ɵngcc0.ɵɵtext(19, "\n                ");
        ɵngcc0.ɵɵelement(20, "span", 9);
        ɵngcc0.ɵɵtext(21, "\n                ");
        ɵngcc0.ɵɵtemplate(22, ResetPasswordOldStyleComponent_div_22_Template, 2, 2, "div", 10);
        ɵngcc0.ɵɵtext(23, "\n                ");
        ɵngcc0.ɵɵtemplate(24, ResetPasswordOldStyleComponent_div_24_Template, 2, 2, "div", 10);
        ɵngcc0.ɵɵtext(25, "\n                ");
        ɵngcc0.ɵɵtemplate(26, ResetPasswordOldStyleComponent_div_26_Template, 2, 3, "div", 11);
        ɵngcc0.ɵɵtext(27, "\n                ");
        ɵngcc0.ɵɵelementStart(28, "label");
        ɵngcc0.ɵɵtext(29, "Confirm New Password");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(30, "\n                ");
        ɵngcc0.ɵɵelementStart(31, "div", 5);
        ɵngcc0.ɵɵtext(32, "\n                    ");
        ɵngcc0.ɵɵelement(33, "input", 12, 13);
        ɵngcc0.ɵɵtext(35, "\n                    ");
        ɵngcc0.ɵɵelement(36, "span", 9);
        ɵngcc0.ɵɵtext(37, "\n                    ");
        ɵngcc0.ɵɵtemplate(38, ResetPasswordOldStyleComponent_div_38_Template, 2, 2, "div", 10);
        ɵngcc0.ɵɵtext(39, "\n                ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(40, "\n                ");
        ɵngcc0.ɵɵelementStart(41, "button", 14);
        ɵngcc0.ɵɵlistener("doubleClickIsDisabledChange", function ResetPasswordOldStyleComponent_Template_button_doubleClickIsDisabledChange_41_listener($event) { return ctx.doubleClickIsDisabled = $event; });
        ɵngcc0.ɵɵtext(42, "\n                    Save\n                ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(43, "\n                ");
        ɵngcc0.ɵɵelementStart(44, "a", 15);
        ɵngcc0.ɵɵtext(45, " Go Home ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(46, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(47, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(48, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(49, "\n    ");
        ɵngcc0.ɵɵtext(50, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(51, "\n");
        ɵngcc0.ɵɵtext(52, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.logoFull, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1("\n            ", ctx.config.messageOverrides.resetPasswordLabel, "\n        ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formGroup", ctx.resetPasswordForm);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("has-error", ctx.passwordHasError());
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("title", ctx.config.messageOverrides.failedPattern);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showPasswordRequiredError());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showPasswordMustMatchError());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasRegexError());
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵclassProp("has-error", ctx.showConfirmPasswordRequiredError());
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showConfirmPasswordRequiredError());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("doubleClickIsDisabled", ctx.doubleClickIsDisabled);
    } }, directives: [ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc2.NgIf, ɵngcc7.MtPreventDoubleClickDirective, ɵngcc4.RouterLinkWithHref], encapsulation: 2 });
ResetPasswordOldStyleComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ResetPasswordOldStyleComponent, [{
        type: Component,
        args: [{
                selector: 'app-reset-password',
                template: "<div class=\"login-box\">\n    <img class=\"logo-img\" src=\"{{ logoFull }}\" alt=\"Logo\" />\n    <div class=\"login-box-body\">\n        <p class=\"login-box-msg\">\n            {{ config.messageOverrides.resetPasswordLabel }}\n        </p>\n        <form [formGroup]=\"resetPasswordForm\" (ngSubmit)=\"onSubmit()\">\n            <div class=\"form-group has-feedback\" [class.has-error]=\"passwordHasError()\">\n                <label>New Password</label\n                ><i\n                    class=\"fa fa-info-circle\"\n                    aria-hidden=\"true\"\n                    data-toggle=\"tooltip\"\n                    data-html=\"true\"\n                    data-placement=\"right\"\n                    [title]=\"config.messageOverrides.failedPattern\"\n                ></i>\n                <input\n                    #Password\n                    type=\"password\"\n                    autofocus\n                    autocomplete=\"off\"\n                    class=\"form-control\"\n                    placeholder=\"Password\"\n                    formControlName=\"Password\"\n                />\n                <span class=\"fa fa-lock form-control-feedback\"></span>\n                <div *ngIf=\"showPasswordRequiredError()\" class=\"small errortext\" [style.position]=\"'block'\">Password is required</div>\n                <div *ngIf=\"showPasswordMustMatchError()\" class=\"small errortext\" [style.position]=\"'block'\">Passwords must match</div>\n                <div *ngIf=\"hasRegexError()\" class=\"small errortext\" [style.position]=\"'block'\" id=\"failedPatternMessage\">\n                    {{ config.messageOverrides.failedPattern }}\n                </div>\n                <label>Confirm New Password</label>\n                <div class=\"form-group has-feedback\" [class.has-error]=\"showConfirmPasswordRequiredError()\">\n                    <input\n                        #PasswordConfirm\n                        type=\"password\"\n                        autocomplete=\"off\"\n                        class=\"form-control\"\n                        placeholder=\"Confirm Password\"\n                        formControlName=\"ConfirmPassword\"\n                    />\n                    <span class=\"fa fa-lock form-control-feedback\"></span>\n                    <div *ngIf=\"showConfirmPasswordRequiredError()\" class=\"small errortext\" [style.position]=\"'block'\">\n                        Secondary Password is required\n                    </div>\n                </div>\n                <button type=\"submit\" mt-doubleClickDisabled [(doubleClickIsDisabled)]=\"doubleClickIsDisabled\" Class=\"btn btn-flat btn-success\">\n                    Save\n                </button>\n                <a routerLink=\"/login\" class=\"btn btn-default pull-right\"> Go Home </a>\n            </div>\n        </form>\n    </div>\n    <!-- /.login-box-body -->\n</div>\n<!-- /.login-box -->\n"
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class AdminAccessOldStyleComponent extends AdminAccessComponent {
    constructor(injector) {
        super(injector);
        this.navService = injector.get(NavService);
    }
    ngOnInit() {
        super.ngOnInit();
        this.navService.setShowNav(false);
    }
    ngOnDestroy() {
        this.navService.setShowNav(true);
    }
}
AdminAccessOldStyleComponent.ɵfac = function AdminAccessOldStyleComponent_Factory(t) { return new (t || AdminAccessOldStyleComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
AdminAccessOldStyleComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AdminAccessOldStyleComponent, selectors: [["app-admin-access"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function AdminAccessOldStyleComponent_Template(rf, ctx) { }, encapsulation: 2 });
AdminAccessOldStyleComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AdminAccessOldStyleComponent, [{
        type: Component,
        args: [{
                selector: 'app-admin-access',
                template: ""
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

const authServiceFactory = (injector) => {
    return injector.get(LoginModuleOverrideAuthServiceToken, AuthService);
};
const authServiceProvider = {
    deps: [Injector],
    provide: AuthService,
    useFactory: authServiceFactory,
};

function msalInstanceFactory(loginConfig) {
    return new PublicClientApplication({
        auth: loginConfig.microsoftAuthConfig,
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
        },
    });
}

function onAppInit(injector) {
    const answer = () => {
        return new Promise((resolve) => {
            injector.get(LoginService);
            resolve();
        });
    };
    return answer;
}
const ɵ0 = msalInstanceFactory;
class BaseLoginModule {
}
BaseLoginModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BaseLoginModule });
BaseLoginModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BaseLoginModule_Factory(t) { return new (t || BaseLoginModule)(); }, providers: [
        LoginService,
        LoginConfig,
        authServiceProvider,
        {
            deps: [Injector],
            multi: true,
            provide: APP_INITIALIZER,
            useFactory: onAppInit
        },
        {
            deps: [LoginConfig],
            provide: MSAL_INSTANCE,
            useFactory: ɵ0
        },
        MsalService,
    ], imports: [[CommonModule, FormsModule, ReactiveFormsModule, RouterModule, MtPreventDoubleClickButtonModule, PageTitlesModule, MsalModule], CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MtPreventDoubleClickButtonModule,
        PageTitlesModule,
        MsalModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BaseLoginModule, { declarations: function () { return [GoogleLoginComponent, MsLoginComponent]; }, imports: function () { return [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, MtPreventDoubleClickButtonModule, PageTitlesModule, MsalModule]; }, exports: function () { return [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MtPreventDoubleClickButtonModule,
        PageTitlesModule,
        MsalModule, GoogleLoginComponent, MsLoginComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BaseLoginModule, [{
        type: NgModule,
        args: [{
                declarations: [GoogleLoginComponent, MsLoginComponent],
                exports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    RouterModule,
                    MtPreventDoubleClickButtonModule,
                    PageTitlesModule,
                    MsalModule,
                    GoogleLoginComponent,
                    MsLoginComponent,
                ],
                imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, MtPreventDoubleClickButtonModule, PageTitlesModule, MsalModule],
                providers: [
                    LoginService,
                    LoginConfig,
                    authServiceProvider,
                    {
                        deps: [Injector],
                        multi: true,
                        provide: APP_INITIALIZER,
                        useFactory: onAppInit
                    },
                    {
                        deps: [LoginConfig],
                        provide: MSAL_INSTANCE,
                        useFactory: ɵ0
                    },
                    MsalService,
                ]
            }]
    }], null, null); })();
class MtLoginModule {
}
MtLoginModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MtLoginModule });
MtLoginModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MtLoginModule_Factory(t) { return new (t || MtLoginModule)(); }, imports: [[BaseLoginModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MtLoginModule, { declarations: [LoginComponent, ForgotPasswordComponent, ResetPasswordComponent, AdminAccessComponent], imports: [BaseLoginModule], exports: [LoginComponent, GoogleLoginComponent, MsLoginComponent, ForgotPasswordComponent, ResetPasswordComponent, AdminAccessComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtLoginModule, [{
        type: NgModule,
        args: [{
                declarations: [LoginComponent, ForgotPasswordComponent, ResetPasswordComponent, AdminAccessComponent],
                exports: [LoginComponent, GoogleLoginComponent, MsLoginComponent, ForgotPasswordComponent, ResetPasswordComponent, AdminAccessComponent],
                imports: [BaseLoginModule]
            }]
    }], null, null); })();
class MtLoginOldStyleModule {
}
MtLoginOldStyleModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MtLoginOldStyleModule });
MtLoginOldStyleModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MtLoginOldStyleModule_Factory(t) { return new (t || MtLoginOldStyleModule)(); }, imports: [[BaseLoginModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MtLoginOldStyleModule, { declarations: [LoginOldStyleComponent, ForgotPasswordOldStyleComponent, ResetPasswordOldStyleComponent, AdminAccessOldStyleComponent], imports: [BaseLoginModule], exports: [LoginOldStyleComponent, GoogleLoginComponent, MsLoginComponent, ForgotPasswordOldStyleComponent, ResetPasswordOldStyleComponent, AdminAccessOldStyleComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtLoginOldStyleModule, [{
        type: NgModule,
        args: [{
                declarations: [LoginOldStyleComponent, ForgotPasswordOldStyleComponent, ResetPasswordOldStyleComponent, AdminAccessOldStyleComponent],
                exports: [
                    LoginOldStyleComponent,
                    GoogleLoginComponent,
                    MsLoginComponent,
                    ForgotPasswordOldStyleComponent,
                    ResetPasswordOldStyleComponent,
                    AdminAccessOldStyleComponent,
                ],
                imports: [BaseLoginModule]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AdminAccessComponent, AdminAccessOldStyleComponent, ForgotPasswordComponent, ForgotPasswordOldStyleComponent, GoogleLoginComponent, LoginComponent, LoginConfig, LoginOldStyleComponent, LoginService, MsLoginComponent, MtLoginModule, MtLoginOldStyleModule, ResetPasswordComponent, ResetPasswordOldStyleComponent, authServiceFactory, authServiceProvider, onAppInit as ɵa, BaseLoginModule as ɵb, msalInstanceFactory as ɵc };

//# sourceMappingURL=mt-ng2-login-module.js.map